import { Component, Host, h } from "@stencil/core";

/**
 * @slot - Slot for `stzh-menu-item` elements
 */
@Component({
  tag: "stzh-menu",
  styleUrl: "stzh-menu.scss",
  scoped: true,
})
export class StzhMenu {
  render() {
    return (
      <Host role="menu">
        <div class="stzh-menu">
          <slot></slot>
        </div>
      </Host>
    );
  }
}
